import kerela1 from '../../Images/FeaturedDestination/kerela/kerela1.jpg';
import kerela2 from '../../Images/FeaturedDestination/kerela/kerela2.jpg';
import kerela3 from '../../Images/FeaturedDestination/kerela/kerela3.jpg';
import goa1 from '../../Images/FeaturedDestination/Goa/goa1.jpg';
import goa2 from '../../Images/FeaturedDestination/Goa/goa2.jpg';
import goa3 from '../../Images/FeaturedDestination/Goa/goa3.jpg';
import ladakh1 from '../../Images/FeaturedDestination/Ladakh/ladakh1.jpg';
import ladakh2 from '../../Images/FeaturedDestination/Ladakh/ladakh2.jpg';
import ladakh3 from '../../Images/FeaturedDestination/Ladakh/ladakh3.jpg';
import andaman1 from '../../Images/FeaturedDestination/Andaman/andaman1.jpg';
import andaman2 from '../../Images/FeaturedDestination/Andaman/andaman2.jpg';
import andaman3 from '../../Images/FeaturedDestination/Andaman/andaman3.jpg';
import sikkim1 from '../../Images/FeaturedDestination/Sikkim/sikkim1.jpg';
import sikkim2 from '../../Images/FeaturedDestination/Sikkim/sikkim2.jpg';
import sikkim3 from '../../Images/FeaturedDestination/Sikkim/sikkim3.jpg';
import kashmir1 from '../../Images/FeaturedDestination/Kashmir/kashmir1.jpg';
import kashmir2 from '../../Images/FeaturedDestination/Kashmir/kashmir2.jpg';
import kashmir3 from '../../Images/FeaturedDestination/Kashmir/kashmir3.jpg';
import rajasthan1 from '../../Images/FeaturedDestination/Rajasthan/rajasthan1.jpg';
import rajasthan2 from '../../Images/FeaturedDestination/Rajasthan/rajasthan2.jpg';
import rajasthan3 from '../../Images/FeaturedDestination/Rajasthan/rajasthan3.jpg';

const locations = [
    {
      id: "Kerela",
      title: "Serene Getaway in Kerala",
      description: "Experience the lush greenery, tranquil backwaters, and rich cultural heritage of Kerala. ",
      images: [kerela1, kerela2, kerela3],
      region:"Kerela",
      features: ["Accommodation", "Transport"," Guides Services", "Meals", "Activities"], 
      tripDuration: "06 Nights / 07 Days",
      Startpoint : "Guruvayur",
      Endpoint : "Cochin"
    },
    {
      id: "Goa",
      title: "Serene Getaway in Goa",
      description: "Experience the vibrant beaches, scenic coastline, and lively culture of Goa.",
      images: [goa1, goa2, goa3],
      region:"Goa",
      features: ["Accommodation", "Transport", "Guides Services", "Meals", "Activities"],
      tripDuration: "04 Nights / 05 Days",
      Startpoint: "Goa",
      Endpoint: "Goa"
    }
    ,
    {
      id: "Ladakh",
      title: "All Shades of Leh Ladakh",
      description: "Discover the breathtaking landscapes, serene monasteries, and adventure-filled experiences in Leh Ladakh.",
      images: [ladakh1, ladakh2, ladakh3],  // Replace with actual image imports
      region:"Ladakh",
      features: [
        "Accommodation",
        "Transport",
        "Guides Services",
        "Meals",
        "Activities",
        "Other Services"
      ],
      tripDuration: "06 Nights / 07 Days",
      Startpoint: "Leh Ladakh",
      Endpoint: "Leh Ladakh",
    }
    ,
    {
      id: "AndamanNicobar",
      title: "Andaman-Nicobar - Family Holiday Packages",
      description: "Explore the emerald islands of Andaman & Nicobar with serene beaches, historic landmarks, and vibrant marine life.",
      images: [andaman1, andaman2, andaman3], 
      features: ["Accommodation", "Transport", "Guides Services", "Meals", "Activities", "Other Services"],
      tripDuration: "05 Nights / 06 Days",
      Startpoint: "Port Blair",
      Endpoint: "Port Blair"
    },
    {
      id: "GangtokNorthSikkim",
      title: "Gangtok and North Sikkim Tour",
      description: "A mesmerizing 7-day journey through Gangtok, Lachen, Lachung, and Yumthang Valley, offering spiritual tranquility, breathtaking mountain views, and vibrant local culture.",
      images: [sikkim1, sikkim2, sikkim3], // Replace with actual imported image variables
      region: "Sikkim",
      features: ["Accommodation", "Transport", "Guides Services", "Meals", "Activities", "Other Services"],
      tripDuration: "06 Nights / 07 Days",
      Startpoint: "Sikkim",
      Endpoint: "Sikkim"
    }
    ,
    {
      id: "KashmirSummer",
      title: "Kashmir Packages",
      description: "Experience the breathtaking beauty of Kashmir through Srinagar, Sonamarg, Pahalgam, and Gulmarg. Enjoy serene lakes, Mughal gardens, and snow-capped peaks in this 5-day summer tour.",
      images: [kashmir1, kashmir2, kashmir3], // Replace with actual imported image variables
      region: "Kashmir",
      features: ["Accommodation", "Transport", "Guides Services", "Meals", "Activities", "Other Services"],
      tripDuration: "04 Nights / 05 Days",
      Startpoint: "Srinagar",
      Endpoint: "Gulmarg"
    }
    ,
    {
      id: "RajasthanTour",
      title: "Best of Rajasthan Tour Packages",
      description: "Explore the royal grandeur of Rajasthan over 11 days, covering Delhi, Mandawa, Bikaner, Jaisalmer, Jodhpur, Udaipur, and Jaipur. Experience palaces, forts, temples, camel safaris, and vibrant culture.",
      images: [rajasthan1, rajasthan2, rajasthan3], // Replace with imported image variables
      region: "Rajasthan",
      features: ["Accommodation", "Transport", "Guides Services", "Meals", "Activities", "Other Services"],
      tripDuration: "10 Nights / 11 Days",
      Startpoint: "Delhi",
      Endpoint: "Jaipur"
    }
    
  ];
  
  export default locations;
  